import { Button, Tag } from 'antd';

import { InfoBlock } from 'app/components/commons/InfoBlock/InfoBlock';
import { usePublishReview } from 'app/hooks/data/core/admin/reviews/usePublishReview';
import { useUnpublishReview } from 'app/hooks/data/core/admin/reviews/useUnpublishReview';
import type { BookingReviewResponse } from 'app/typings/core/admin/bookings/booking';
import { BOOKING_REVIEW_STATUS } from 'app/typings/core/admin/bookings/enum/bookingReviewStatus';
import { dateAndHour } from 'app/utils/dates';

import { formatBookingReviewStatus } from './utils';

type UserReviewProps = {
  bookingCode: string;
  review: BookingReviewResponse;
  onEditReview: (reviewId: number) => void;
};

export const UserReview = ({
  bookingCode,
  review,
  onEditReview,
}: UserReviewProps) => {
  const { mutateAsync: publishReview } = usePublishReview();
  const { mutateAsync: unpublishReview } = useUnpublishReview();

  const { label: reviewLabel, color: reviewColor } = formatBookingReviewStatus(
    review.status
  );

  const handleTogglePublish = async () => {
    const action =
      review.status === BOOKING_REVIEW_STATUS.PUBLISHED
        ? unpublishReview
        : publishReview;

    await action({ reviewId: review.id, bookingCode });
  };

  return (
    <InfoBlock
      title="Feedback"
      actions={
        <>
          <Button onClick={handleTogglePublish}>
            {review.status === BOOKING_REVIEW_STATUS.PUBLISHED
              ? 'Unpublish'
              : 'Publish'}
          </Button>
          <Button onClick={() => onEditReview(review.id)}>Edit</Button>
        </>
      }
      rows={[
        {
          label: 'Feedback ID',
          value: review.id,
        },
        {
          label: 'Status',
          value: <Tag color={reviewColor}>{reviewLabel}</Tag>,
        },
        {
          label: 'Created at',
          value: dateAndHour(review.createdAt),
        },
        {
          label: 'Comment',
          value: review.comment,
        },
        {
          label: 'Global rating',
          value: review.globalScore,
        },
        {
          label: 'Experience',
          value: review.experienceScore,
        },
        {
          label: 'Service',
          value: review.serviceScore,
        },
        {
          label: 'Vibe',
          value: review.vibeScore,
        },
        {
          label: 'Room',
          value: review.roomScore ?? '-',
        },
        {
          label: 'Breakfast',
          value: review.breakfastScore ?? '-',
        },
      ]}
    />
  );
};
